import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../shared';
import { LOCAL_STORAGE, TITLES } from '../../constants';
import { getLocalStorageItem } from '../../utils';

export const TitleBar = ({ title, listView, setListView }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTitleClick = (index) => {
    // Only handle breadcrumb navigation if it's a valid route and not the last item
    if (index + 1 < title.length && title[index].route !== '') {
      const listUrl = location.state?._listUrl;
      if (listUrl && listUrl.startsWith(title[index].route)) {
        navigate(listUrl);
      } else {
        navigate(title[index].route);
      }
    }
  };

  const handleViewToggle = () => {
    setListView(!listView);
  };

  const vendor_type = getLocalStorageItem(LOCAL_STORAGE.VENDOR_TYPE);

  return (
    <div className="title-bar bg-white w-100 mb-3">
      <div className="d-flex align-items-center justify-content-between">
        <h4 className="mb-3 justify-content-start">
          {title.map((sub, index) =>
            sub.text !== '' ? (
              <span
                key={index}
                onClick={() => handleTitleClick(index)}
                style={{ cursor: index < title.length - 1 ? 'pointer' : 'default' }}>
                {index > 0 ? ' > ' : ''}
                {index + 1 < title.length && title[index].route !== '' ? (
                  <span className="text-primary">{sub.text}</span>
                ) : (
                  sub.text
                )}
              </span>
            ) : (
              ''
            ),
          )}
        </h4>
        {vendor_type === 'clothing' &&
          title?.length === 1 &&
          title?.[0]?.text === TITLES.MANUFACTURING && (
            <Button clickHandler={handleViewToggle} className="blue-btn mb-3 px-3">
              Toggle View
            </Button>
          )}
      </div>
    </div>
  );
};
